import React from 'react';
import { ArticleOutlined, Store } from '@mui/icons-material';
import { documentationUrl, sitemap } from 'app/shared/util/url-utils';
import { Translate } from 'react-jhipster';
import AppsIcon from '@mui/icons-material/Apps';
import { UserCircle } from 'tabler-icons-react';
import { useCurrentAccountPermissions } from 'app/shared/restricted/hooks/usePermission';

export const managementRoutes = () => {
  const permissions = useCurrentAccountPermissions();
  const has = (permission?: string) => !permission || permissions.includes(permission);

  return [
    {
      path: sitemap.account,
      // permission: 'account:read',
      sidebarProps: {
        displayText: <Translate contentKey="module-factory.account">Account</Translate>,
        icon: <Store />,
      },
    },
    {
      path: sitemap.user,
      sidebarProps: {
        displayText: <Translate contentKey="module-factory.profile">Profile</Translate>,
        icon: <UserCircle />,
      },
    },
    {
      path: sitemap.applications,
      sidebarProps: {
        displayText: <Translate contentKey="module-factory.applications">Applications</Translate>,
        icon: <AppsIcon />,
      },
    },
    {
      path: sitemap.home,
      target: '_blank',
      sidebarProps: {
        displayText: <Translate contentKey="module-factory.documentation">Documentation</Translate>,
        icon: <ArticleOutlined />,
      },
    },
  ].filter(route => has((route as any).permission));
};
